/** Keep in sync with utils.js IndexedDB names for migration. */
export const DB_NAME = 'crashSyncDB'
export const STORE_NAME = 'pendingRequests'
